import type {
    BulkOnboardingPublishPagePropertyOnboardingContextFieldsV1,
    BulkOnboardingPublishPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import type {
    TaxIdToggleElementPropertyOnboardingFieldsV1,
    TaxIdToggleElementPropertyOnboardingIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/elements.split";
import {
    BulkOnboardingPublishPagePropertyOnboardingContextManifestV1,
    WebBulkOnboardingPublishPageVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/bulk-onboarding-publish-page";
import {
    AckTermsConditionsElementPropertyOnboardingManifestV1,
    BulkOnboardingBackElementPropertyOnboardingManifestV1,
    BulkOnboardingNextElementPropertyOnboardingManifestV1,
    BulkOnboardingSaveAndExitElementPropertyOnboardingManifestV1,
    GstIdElementPropertyOnboardingManifestV1,
    LocalLawsRegulationsElementPropertyOnboardingManifestV1,
    PermanentAccountNumberElementPropertyOnboardingManifestV1,
    PrivacyPolicyElementPropertyOnboardingManifestV1,
    TaxIdToggleElementPropertyOnboardingManifestV1,
    TermsConditionsElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping } from "libs/analytics/functions/appContext";
import { defineBinder } from "libs/analytics/functions/defineBinder";

export const batchPublishBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<
        BulkOnboardingPublishPagePropertyOnboardingContextIdsV1,
        BulkOnboardingPublishPagePropertyOnboardingContextFieldsV1
    >(BulkOnboardingPublishPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebBulkOnboardingPublishPageVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], BulkOnboardingSaveAndExitElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BulkOnboardingBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BulkOnboardingNextElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], AckTermsConditionsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], TermsConditionsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PrivacyPolicyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocalLawsRegulationsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PermanentAccountNumberElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], GstIdElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement<
        TaxIdToggleElementPropertyOnboardingIdsV1,
        TaxIdToggleElementPropertyOnboardingFieldsV1
    >([click, reveal], TaxIdToggleElementPropertyOnboardingManifestV1.ids, {});
});
